import { render, staticRenderFns } from "./MailGroups.edit.vue?vue&type=template&id=09d3c88a&"
import script from "./MailGroups.edit.vue?vue&type=script&lang=js&"
export * from "./MailGroups.edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports